import { Interjection } from '../../types'
import ёба from './ёба'
import бля from './бля'
import блять from './блять'
import ёпт from './ёпт'

const interjections: Array<Interjection> = [бля, блять, ёба, ёпт]

export default interjections
